'use strict';

exports.__esModule = true;
exports['default'] = memoize;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _singletonCache = require('./singletonCache');

var _singletonCache2 = _interopRequireDefault(_singletonCache);

var _lruCache = require('./lruCache');

var _lruCache2 = _interopRequireDefault(_lruCache);

var _deepEquals = require('./deepEquals');

var _deepEquals2 = _interopRequireDefault(_deepEquals);

function createCache(limit, equals) {
  return limit === 1 ? _singletonCache2['default'](equals) : _lruCache2['default'](limit, equals);
}

function memoize() {
  var limit = 1;
  var equals = function equals(valueA, valueB) {
    return valueA === valueB;
  };
  var deepObjects = false;

  for (var _len = arguments.length, config = Array(_len), _key = 0; _key < _len; _key++) {
    config[_key] = arguments[_key];
  }

  if (typeof config[0] === 'number') {
    limit = config.shift();
  }
  if (typeof config[0] === 'function') {
    equals = config.shift();
  }
  if (typeof config[0] === 'boolean') {
    deepObjects = config[0];
  }

  var cache = createCache(limit, _deepEquals2['default'](equals, deepObjects));

  return function (fn) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var value = cache.get(args);
      if (value === undefined) {
        value = fn.apply(fn, args);
        cache.put(args, value);
      }
      return value;
    };
  };
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/lru-memoize/lib/memoize.js
 ** module id = 969
 ** module chunks = 0
 **/